import { PLAN_SIGNATURES } from "../config/module";

const parseJwtPayload = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

export const permissionService = {
  // ---------- GET ALLOWED MODULES ----------
  getAllowedModules() {
    if (this.isPlatformAdmin()) {
      return [1, 2, 4, 5]; 
    }

    let modules = localStorage.getItem("accessModules");

    try {
      modules = modules ? JSON.parse(modules) : [];
    } catch (e) {
      console.warn("Invalid accessModules in localStorage, resetting to []");
      modules = [];
    }

    if (!Array.isArray(modules)) return [];

    return modules
      .map((m) => {
        if (typeof m === "number") return m;
        if (typeof m === "string" && m.trim() !== "" && !Number.isNaN(Number(m))) {
          return Number(m);
        }
        if (m && typeof m.id === "number") return m.id;
        if (m && typeof m.customized_module_id === "number") return m.customized_module_id;
        if (m && typeof m.module_management_id === "number") return m.module_management_id;
        if (m && typeof m.module_id === "number") return m.module_id;
        return null;
      })
      .filter((id) => Number.isInteger(id) && id > 0); // remove invalid values
  },

  // ---------- CHECK MODULES ----------
  hasAny(moduleIds = []) {
    const allowed = this.getAllowedModules();
    return moduleIds.some((id) => allowed.includes(id));
  },

  hasAll(moduleIds = []) {
    const allowed = this.getAllowedModules();
    return moduleIds.every((id) => allowed.includes(id));
  },

  has(moduleId) {
    return this.getAllowedModules().includes(moduleId);
  },

  isAdmin() {
    const role = localStorage.getItem("role");
    if (role === "admin") return true;
    if (role === "user") return false;
    // Role is set at login; do not decode a client-held JWT (cookie auth).
    return false;
  },

  isTenantConsoleView() {
    return localStorage.getItem("portalTenantView") === "1";
  },

  /** Nyafaz platform admin (not portal org tenant console). */
  isPlatformAdmin() {
    if (this.isTenantConsoleView()) return false;
    return this.isAdmin();
  },

  /** Tenant menus (plan, billing, dashboard): org owner or admin in an org context. */
  showTenantUserMenus() {
    if (this.isTenantConsoleView()) return true;
    if (!this.isAdmin()) return true;
    const orgId = localStorage.getItem("orgId");
    return Boolean(orgId && orgId !== "undefined" && orgId !== "null");
  },

  getPlan() {
    return (localStorage.getItem("plan") || "").toLowerCase();
  },

  getPlanStatus() {
    return (localStorage.getItem("plan_status") || "active").toLowerCase();
  },

  getDisplayPlanLabel() {
    const plan = this.getPlan();
    const status = this.getPlanStatus();
    const formattedPlan = plan
      ? plan.charAt(0).toUpperCase() + plan.slice(1)
      : "Free";

    if (status === "trial_active") {
      return `Trial - ${formattedPlan}`;
    }

    return `${formattedPlan} Plan`;
  },

  // ---------- SET ALLOWED MODULES ----------
  setAllowedModules(plan, customModules = []) {
    const defaultModules = PLAN_SIGNATURES[plan] || [];
    const mergedModules = [...new Set([...defaultModules, ...customModules])];
    localStorage.setItem("accessModules", JSON.stringify(mergedModules));
    return mergedModules;
  },
};
